import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./styles.module.css";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "src/@/components/ui/table";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "src/@/components/ui/tabs";
// import { AddCreators } from "src/components/designSystem/organisms/AddCreators";
import {
  getCreatorMarketplaceCreators,
  getPages,
  sendCreatorMessage,
  getPartnershipConversations,
  getPartnershipMessages,
  getPartnershipContacts,
} from "src/api/pages";
import { getUserInfo } from "src/api/login";
import { Link } from "react-router-dom";
import {
  getConversations,
  refreshIgConversations,
  // getFBCreatorConversation,
  // getTaggedFBPosts,
} from "src/api/conversations";
// import { getFBConversations, getTaggedPosts } from "src/utils/FbApiHandlers";
import moment from "moment";
import { getCreators } from "src/api/creators";
import { ChatBox } from "src/components/designSystem/organisms/ChatView";
import { toast } from "react-toastify";
import classNames from "classnames";
import { Messanger } from "src/components/designSystem/atoms/icons/messanger";
import { Loader } from "src/components/designSystem/atoms/Loader";
import {
  getFacebookMentions,
  refreshFacebookMentions,
} from "src/api/facebook";
import {
  createPartnershipAd,
  listPartnershipAds,
  goLivePartnershipAd,
  setPartnershipAdStatus,
  deletePartnershipAd,
  getAdsCampaignsLive,
} from "src/api/ads";
const fallbackPic =
  "https://www.pngitem.com/pimgs/m/146-1468479_my-profile-icon-blank-profile-picture-circle-hd.png";

export const NewDashboard: React.FC = () => {
  const [selectedUserName, setSelectedUserName] = useState("");

  // Creator marketplace (tab4) is the landing tab.
  const [tab, setTab] = useState("tab4");

  const [userDetail, setUserDetail] = useState<{
    _id: string;
    accessToken: string;
    name: string;
    instagramId: string;
    password: string;
    username: string;
    createdAt: string;
    updatedAt: string;
  }>({
    _id: "",
    accessToken: "",
    name: "",
    instagramId: "",
    password: "",
    username: "",
    createdAt: "",
    updatedAt: "",
  });
  const [pages, setPages] = useState<
    {
      _id: string;
      userId: string;
      accessToken: string;
      category: string;
      name: string;
      pageId: string;
      createdAt: string;
      updatedAt: string;
      connectedId: string;
      about: string;
      following: string;
      followers: string;
      picture: string;
      username: string;
    }[]
  >([]);
  const [selected, setSelected] = useState("");
  const [conversations, setConversations] = useState([]);
  const [creators, setCreators] = useState([]);
  const [isLogin, setisLogin] = useState(true);
  const [message, setMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [refreshed, setRefreshed] = useState(false);
  const [marketplaceRows, setMarketplaceRows] = useState<any[]>([]);
  const [marketplaceLoading, setMarketplaceLoading] = useState(false);
  const [marketplaceError, setMarketplaceError] = useState<string | null>(null);
  const [marketplaceQuery, setMarketplaceQuery] = useState("fashion");
  const [marketplaceCountries, setMarketplaceCountries] = useState("US");
  const [marketplaceUsername, setMarketplaceUsername] = useState("");
  const [marketplaceSearchedOnce, setMarketplaceSearchedOnce] = useState(false);
  // Creator Marketplace partnership messaging.
  const [msgCreator, setMsgCreator] = useState<any>(null);
  const [msgText, setMsgText] = useState("");
  const [msgSending, setMsgSending] = useState(false);
  // messaging_id -> count of our sends in the last 30 days. 0 = never messaged
  // (show Message), 1 = messaged (initiated; continue in Partnerships), 2 = at
  // the 2/30-day cap (2207095). Re-searching a messaged creator disables the
  // button — the marketplace only initiates; further replies live in Partnerships.
  const [msgSentByCreator, setMsgSentByCreator] = useState<
    Record<string, number>
  >({});
  // Partnership-folder threads shown in the Chats tab.
  const [pThreads, setPThreads] = useState<any[]>([]);
  const [pThreadsLoading, setPThreadsLoading] = useState(false);
  const [pSelectedThread, setPSelectedThread] = useState<string | null>(null);
  const [pMessages, setPMessages] = useState<any[]>([]);
  const [pMessagesLoading, setPMessagesLoading] = useState(false);
  const [pReplyText, setPReplyText] = useState("");
  const [pReplying, setPReplying] = useState(false);

  // Tagged media (posts + reels) from the /tags edge — story mentions come from
  // conversations, tags come from here.
  const [fbTags, setFbTags] = useState<any[]>([]);
  const [tagsLoading, setTagsLoading] = useState(false);
  // Partnership ads
  const [adsByMedia, setAdsByMedia] = useState<Record<string, any>>({});
  const [boostFor, setBoostFor] = useState<any>(null);
  const [boosting, setBoosting] = useState(false);
  const [adActionId, setAdActionId] = useState<string | null>(null);
  const [boostForm, setBoostForm] = useState({
    name: "",
    objective: "OUTCOME_AWARENESS",
    dailyBudgetUsd: 20,
    countries: "US",
    ctaType: "LEARN_MORE",
    ctaLink: "",
    dryRun: false,
  });
  const [liveCampaigns, setLiveCampaigns] = useState<any[]>([]);
  const [liveLoading, setLiveLoading] = useState(false);
  const [liveError, setLiveError] = useState<string | null>(null);
  const [adAccountId, setAdAccountId] = useState<string>("");
  const [businessId, setBusinessId] = useState<string>("");
  // Creator branded-content permission per creator_username (lowercased):
  // APPROVED | PENDING | REVOKED.
  const [creatorPermissions, setCreatorPermissions] = useState<
    Record<string, string>
  >({});
  const [expandedCampaigns, setExpandedCampaigns] = useState<
    Record<string, boolean>
  >({});
  const marketplaceSearchRef = useRef({
    query: "fashion",
    countries: "US",
    username: "",
  });
  marketplaceSearchRef.current = {
    query: marketplaceQuery,
    countries: marketplaceCountries,
    username: marketplaceUsername,
  };
  // const [tagged, setTagged] = useState([]);

  // const getConversations = useCallback(() => {
  //   console.log("getConversations");
  // }, []);

  useEffect(() => {
    getPages().then((res: any) => {
      if (res) {
        setPages(res.data);
        setSelected(res.data[0]._id);
        setLoader(true);
        // Paint from the database straight away so the dashboard is usable...
        getPageConversations(res.data[0]._id);
        // ...then sync fresh data from Meta in the background (first load only).
        if (!refreshed) {
          refreshConversations(res.data[0]._id, true);
        }
      }
    });
    getUserInfo().then((res: any) => {
      if (res) {
        setUserDetail(res);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshed]);

  const getUserPageInfo = () => {
    if (typeof FB !== "undefined" && typeof FB === "object") {
      FB.getLoginStatus((response) => {
        if (response.status === "connected") {
          setisLogin(true);
        }
      });
    }
  };

  useEffect(() => {
    getUserPageInfo();
  }, []);

  useEffect(() => {
    setMarketplaceSearchedOnce(false);
    setMarketplaceRows([]);
    setMarketplaceError(null);
  }, [selected]);

  // Tagged media (posts/reels) via the /tags edge. Story mentions come from
  // conversations; both feed the Mentions tab, so Refresh reloads both.
  // `fromApi: true` re-pulls from the Graph API (slow); otherwise the backend
  // serves its cache so the tab paints immediately.
  const loadFbTags = async (fromApi = false) => {
    setTagsLoading(true);
    try {
      const res: any = fromApi
        ? await refreshFacebookMentions()
        : await getFacebookMentions();
      setFbTags(res?.data || []);
    } catch (err: any) {
      // Non-fatal: story mentions still render without tags.
      console.log(
        "failed to load tagged media",
        err?.response?.data?.error || err?.message
      );
    } finally {
      setTagsLoading(false);
    }
  };

  useEffect(() => {
    loadFbTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Badge label + colour for a boost-permission status. The status is driven by
  // the backend cron (adStatusPoller), which polls the pushed ad's review state
  // every 5 min and flips Request sent -> Accepted / Rejected.
  const adStatusMeta = (s: string) =>
    s === "accepted"
      ? { label: "Accepted", cls: "bg-green-600" }
      : s === "rejected"
        ? { label: "Rejected", cls: "bg-red-600" }
        : s === "requested"
          ? { label: "Request sent", cls: "bg-yellow-500" }
          : { label: "—", cls: "bg-gray-300" };

  // Existing partnership ads, indexed by creator media id.
  useEffect(() => {
    listPartnershipAds()
      .then((res: any) => {
        const map: Record<string, any> = {};
        (res?.data || []).forEach((a: any) => {
          if (a.creatorMediaId && a.status !== "DELETED")
            map[a.creatorMediaId] = a;
        });
        setAdsByMedia(map);
      })
      .catch(() => {});
  }, []);

  const loadLiveCampaigns = async () => {
    setLiveLoading(true);
    setLiveError(null);
    try {
      const res = await getAdsCampaignsLive();
      setLiveCampaigns(res?.data || []);
      setAdAccountId(res?.adAccountId || "");
      setBusinessId(res?.businessId || "");
      setCreatorPermissions(res?.permissions || {});
    } catch (err: any) {
      setLiveError(
        err?.response?.data?.error || err?.message || "Failed to load ads"
      );
    } finally {
      setLiveLoading(false);
    }
  };

  // Deep link into Ads Manager for a campaign (optionally pre-selecting an ad set).
  const adsManagerUrl = (campaignId: string, adsetId?: string) => {
    const act = (adAccountId || "").replace(/^act_/, "");
    if (!act || !campaignId) return null;
    const params = new URLSearchParams({ act });
    if (businessId) {
      params.set("business_id", businessId);
      params.set("global_scope_id", businessId);
    }
    params.set("selected_campaign_ids", campaignId);
    if (adsetId) params.set("selected_adset_ids", adsetId);
    return `https://adsmanager.facebook.com/adsmanager/manage/ads?${params.toString()}`;
  };
  useEffect(() => {
    loadLiveCampaigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Partnership ads only run on permanent media (feed posts / reels).
  const isBoostable = (m: any) => {
    const pt = (m.media_product_type || "").toUpperCase();
    if (pt === "STORY") return false;
    if (pt) return pt === "REELS" || pt === "FEED" || pt === "AD";
    return ["IMAGE", "VIDEO", "CAROUSEL_ALBUM"].includes(
      (m.media_type || "").toUpperCase()
    );
  };

  const effClass = (s = "") =>
    s === "ACTIVE"
      ? "bg-green-600"
      : /DISAPPROVED|ERROR|WITH_ISSUES|DENIED/.test(s)
        ? "bg-red-600"
        : /PENDING|IN_REVIEW|REVIEW/.test(s)
          ? "bg-blue-500"
          : /PAUSED/.test(s)
            ? "bg-yellow-500"
            : "bg-gray-500";

  const mediaInfo = (mediaId: string) =>
    fbTags.find((m: any) => m.id === mediaId) || null;
  const recordForCampaign = (campaignId: string) =>
    Object.values(adsByMedia).find((r: any) => r.campaignId === campaignId) ||
    null;

  // Creator's branded-content permission for a campaign's creator, for display.
  const creatorPermissionMeta = (campaignId: string) => {
    const rec: any = recordForCampaign(campaignId);
    const uname = (rec?.creatorUsername || "").toLowerCase();
    const status = uname ? creatorPermissions[uname] : undefined;
    if (!status) return null;
    const s = status.toUpperCase();
    if (s === "APPROVED")
      return { label: "Creator approved", cls: "bg-green-600" };
    if (s === "REVOKED" || s === "REJECTED")
      return { label: "Creator revoked", cls: "bg-red-600" };
    return { label: "Creator pending", cls: "bg-yellow-500" };
  };

  const openBoost = (m: any) => {
    setBoostFor(m);
    setBoostForm({
      name: `Boost @${m.username || "creator"}`,
      objective: "OUTCOME_AWARENESS",
      dailyBudgetUsd: 20,
      countries: "US",
      ctaType: "LEARN_MORE",
      ctaLink: "",
      dryRun: false,
    });
  };

  const submitBoost = async () => {
    if (!boostFor) return;
    setBoosting(true);
    try {
      const res = await createPartnershipAd({
        creatorMediaId: boostFor.id,
        creatorUsername: boostFor.username,
        name: boostForm.name,
        objective: boostForm.objective,
        dailyBudget: Math.round(Number(boostForm.dailyBudgetUsd) * 100),
        countries: boostForm.countries
          .split(",")
          .map((c) => c.trim().toUpperCase())
          .filter(Boolean),
        cta: boostForm.ctaType
          ? {
              type: boostForm.ctaType,
              ...(boostForm.ctaLink ? { link: boostForm.ctaLink } : {}),
            }
          : null,
        dryRun: boostForm.dryRun,
      });
      if (boostForm.dryRun) {
        toast.success("Dry run — payload logged, nothing created");
      } else {
        const record = res?.data;
        if (record?.creatorMediaId) {
          setAdsByMedia((prev) => ({
            ...prev,
            [record.creatorMediaId]: record,
          }));
        }
        // Pushing the ad = the boost request. Reflect "Request sent" now; the
        // cron flips it to Accepted/Rejected once the ad is reviewed.
        setFbTags((prev) =>
          prev.map((m) =>
            m.id === boostFor.id ? { ...m, adStatus: "requested" } : m
          )
        );
        toast.success(
          res?.idempotent
            ? "An ad already exists for this post"
            : "Partnership ad created — request sent"
        );
        setBoostFor(null);
        loadLiveCampaigns();
      }
    } catch (err: any) {
      toast.error(
        err?.response?.data?.error || err?.message || "Failed to create ad"
      );
    } finally {
      setBoosting(false);
    }
  };

  const handleGoLive = async (rec: any) => {
    setAdActionId(rec._id);
    try {
      const res = await goLivePartnershipAd(rec._id);
      const next = res?.data || { ...rec, status: "ACTIVE" };
      setAdsByMedia((prev) => ({ ...prev, [next.creatorMediaId]: next }));
      toast.success("Ad launched — pending Meta review");
      loadLiveCampaigns();
    } catch (err: any) {
      toast.error(err?.response?.data?.error || err?.message || "Launch failed");
    } finally {
      setAdActionId(null);
    }
  };

  const handleAdStatus = async (rec: any, status: string) => {
    setAdActionId(rec._id);
    try {
      const res = await setPartnershipAdStatus(rec._id, status);
      const next = res?.data || { ...rec, status };
      setAdsByMedia((prev) => ({ ...prev, [next.creatorMediaId]: next }));
      toast.success(`Ad ${status.toLowerCase()}`);
      loadLiveCampaigns();
    } catch (err: any) {
      toast.error(err?.response?.data?.error || err?.message || "Update failed");
    } finally {
      setAdActionId(null);
    }
  };

  const handleDeleteAd = async (rec: any) => {
    if (
      !window.confirm(
        "Permanently delete this ad campaign? This cannot be undone."
      )
    )
      return;
    setAdActionId(rec._id);
    try {
      await deletePartnershipAd(rec._id);
      setAdsByMedia((prev) => {
        const next = { ...prev };
        delete next[rec.creatorMediaId];
        return next;
      });
      toast.success("Ad deleted");
      loadLiveCampaigns();
    } catch (err: any) {
      toast.error(err?.response?.data?.error || err?.message || "Delete failed");
    } finally {
      setAdActionId(null);
    }
  };

  const getPageConversations = (pageId: string) => {
    // if (pages[0]) {
    //   getFBCreatorConversation({
    //     token: pages[0].accessToken,
    //     pageId: pages[0].pageId,
    //   }).then((response: any) => {
    //     const tempConversations = response.data.reduce((acc: any[], x: any) => {
    //       const stories = x.messages.data.filter(
    //         (msg: any) => msg.story !== undefined
    //       );
    //       if (stories) {
    //         return [...acc, ...stories];
    //       }
    //       return acc;
    //     }, []);
    //     const conversations = tempConversations
    //       .map((x: any) => {
    //         const creator: any = creators.find(
    //           (creator: any) => creator.username === x.from.username
    //         );
    //         const payload: any = {
    //           media: x.story.mention.link,
    //           messageCreatedAt: x.created_time,
    //           messageType: "story",
    //           name: "",
    //           username: "",
    //           profilePic: "",
    //           followers: 0,
    //         };
    //         if (creator) {
    //           payload["name"] = creator.name;
    //           payload["username"] = creator.username;
    //           payload["profilePic"] = creator.profilePic;
    //           payload["followers"] = creator.followers;
    //         }

    //         return payload;
    //       })
    //       .filter((x: any) => x.name !== "");
    //     setConversations(conversations);
    //   });
    // }
    getConversations(pageId).then((res: any) => {
      setConversations(res.data);
      setLoader(false);
    });
  };

  const getPageCreators = useCallback(() => {
    getCreators().then((res: any) => {
      if (res) {
        setCreators(res.data);
        // getPageConversations();
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const getPageTaggedPosts = useCallback(() => {
  //   if (pages && pages[0]) {
  //     getTaggedFBPosts(pages[0].connectedId, pages[0].pageId).then(
  //       (res: any) => {
  //         setTagged(res);
  //       }
  //     );
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pages]);

  // useEffect(() => {
  //   getPageTaggedPosts();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selected]);

  // `background: true` skips the blocking loader — used on first paint so the
  // dashboard renders from the DB immediately while Meta data syncs behind it.
  const refreshConversations = async (pageId: string, background = false) => {
    if (!background) setLoader(true);
    refreshIgConversations()
      .then(async () => {
        await getPageConversations(pageId);
        await getPageCreators();
        if (!refreshed) {
          setRefreshed(true);
        }
      })
      .catch(() => {
        if (!background) setLoader(false);
      });
  };

  const loadCreatorMarketplace = useCallback(async () => {
    if (!selected) return;
    const { query, countries, username } = marketplaceSearchRef.current;
    setMarketplaceLoading(true);
    setMarketplaceError(null);
    try {
      const res = await getCreatorMarketplaceCreators(selected, {
        // Individual username lookup takes precedence over keyword/country.
        ...(username?.trim()
          ? { username: username.trim() }
          : { query, creator_countries: countries }),
        limit: 25,
      });
      const payload = res?.data as { data?: any[] };
      setMarketplaceRows(Array.isArray(payload?.data) ? payload.data : []);
    } catch (err: any) {
      setMarketplaceRows([]);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "Failed to load creator marketplace";
      const text = typeof msg === "string" ? msg : JSON.stringify(msg);
      setMarketplaceError(text);
      toast.error(text);
    } finally {
      setMarketplaceLoading(false);
      setMarketplaceSearchedOnce(true);
    }
  }, [selected]);

  const sendPartnershipMessage = async () => {
    if (!msgCreator?.messaging_id || !msgText.trim()) return;
    setMsgSending(true);
    try {
      await sendCreatorMessage({
        pageDocId: selected,
        messagingId: msgCreator.messaging_id,
        text: msgText.trim(),
        username: msgCreator.username,
      });
      toast.success(`Message sent to @${msgCreator.username || "creator"}`);
      setMsgCreator(null);
      setMsgText("");
      // Take the user to the Partnerships tab to show the sent message.
      setTab("tab6");
      loadPartnershipThreads();
      loadPartnershipContacts();
    } catch (err: any) {
      toast.error(
        err?.response?.data?.details ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to send message"
      );
    } finally {
      setMsgSending(false);
    }
  };

  const loadPartnershipThreads = useCallback(async () => {
    if (!selected) return;
    setPThreadsLoading(true);
    try {
      const res: any = await getPartnershipConversations(selected);
      // Dedupe by creator username so the same creator shows once even if Meta
      // returns more than one thread id — keep the most recently updated one.
      const byCreator = new Map<string, any>();
      (res?.data || []).forEach((t: any) => {
        const uname = (
          t.creatorUsername ||
          t.participants?.data?.find((p: any) => p.username)?.username ||
          t.id ||
          ""
        ).toLowerCase();
        const existing = byCreator.get(uname);
        if (
          !existing ||
          new Date(t.updated_time || 0).getTime() >
            new Date(existing.updated_time || 0).getTime()
        ) {
          byCreator.set(uname, t);
        }
      });
      setPThreads(Array.from(byCreator.values()));
    } catch (err: any) {
      // Non-fatal (needs marketplace-messaging permission + onboarding).
      console.log(
        "partnership threads",
        err?.response?.data?.details || err?.message
      );
      setPThreads([]);
    } finally {
      setPThreadsLoading(false);
    }
  }, [selected]);

  const loadPartnershipContacts = useCallback(async () => {
    try {
      const res: any = await getPartnershipContacts();
      const map: Record<string, number> = {};
      (res?.data || []).forEach((c: any) => {
        if (c.messagingId) map[c.messagingId] = Number(c.sentCount30d) || 0;
      });
      setMsgSentByCreator(map);
    } catch {
      /* non-fatal */
    }
  }, []);
  useEffect(() => {
    loadPartnershipContacts();
  }, [loadPartnershipContacts]);

  const openPartnershipThread = async (conversationId: string) => {
    setPSelectedThread(conversationId);
    setPReplyText("");
    setPMessagesLoading(true);
    try {
      const res: any = await getPartnershipMessages(conversationId, selected);
      // API returns newest-first; show oldest-first.
      setPMessages([...(res?.data || [])].reverse());
    } catch (err: any) {
      setPMessages([]);
      toast.error(
        err?.response?.data?.details || err?.message || "Failed to load thread"
      );
    } finally {
      setPMessagesLoading(false);
    }
  };

  // The creator's messaging_id = the participant in the thread that isn't our
  // Page (a message's from/to id). Needed to reply.
  const partnershipRecipientId = () => {
    const pageId = page?.pageId;
    for (const m of pMessages) {
      if (m.from?.id && m.from.id !== pageId) return m.from.id;
      const toId = m.to?.data?.find((t: any) => t.id && t.id !== pageId)?.id;
      if (toId) return toId;
    }
    return null;
  };

  const sendPartnershipReply = async () => {
    const messagingId = partnershipRecipientId();
    const text = pReplyText.trim();
    if (!messagingId || !text || !pSelectedThread) return;
    setPReplying(true);
    try {
      await sendCreatorMessage({ pageDocId: selected, messagingId, text });
      setPReplyText("");
      // Optimistic append; then refresh from Graph.
      setPMessages((prev) => [
        ...prev,
        {
          id: `local-${Date.now()}`,
          message: text,
          from: { id: page?.pageId, username: page?.username },
          created_time: new Date().toISOString(),
        },
      ]);
      openPartnershipThread(pSelectedThread);
      loadPartnershipContacts();
    } catch (err: any) {
      toast.error(
        err?.response?.data?.details || err?.message || "Failed to send reply"
      );
    } finally {
      setPReplying(false);
    }
  };

  // Load partnership threads when the Partnerships tab is open.
  useEffect(() => {
    if (tab === "tab6") loadPartnershipThreads();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, selected]);

  // Docs rule: before a creator replies, a brand may send at most 2 messages per
  // 30 days. Once the creator replies, standard limits apply. Returns whether the
  // reply field should be disabled for the currently open thread.
  const partnershipSendBlocked = () => {
    const pageId = page?.pageId;
    const creatorReplied = pMessages.some(
      (m) => m.from?.id && m.from.id !== pageId
    );
    if (creatorReplied) return false;
    const cutoff = Date.now() - 30 * 24 * 60 * 60 * 1000;
    const sentLast30 = pMessages.filter(
      (m) =>
        m.from?.id === pageId &&
        (!m.created_time || new Date(m.created_time).getTime() >= cutoff)
    ).length;
    return sentLast30 >= 2;
  };

  const page = pages?.find((page: any) => page._id === selected);

  return (
    <div className={styles.wrapper}>
      <div
        className={classNames(
          "flex justify-center w-full",
          styles.profileWrapper
        )}
      >
        {page && isLogin ? (
          <div
            className={classNames(
              "p-4 bg-white rounded shadow-md",
              styles.profileBlock
            )}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <img
                  src={page.picture}
                  alt="User Profile"
                  className="w-16 h-16 mr-4 rounded-full"
                />
                <div>
                  <h2 className="text-2xl font-semibold">{page.name}</h2>
                  <a
                    className="text-gray-600"
                    href={`https://instagram.com/${
                      page?.username || page.name
                    }`}
                  >
                    @{page?.username || page.name}
                  </a>
                </div>
              </div>

              <div className="flex">
                <div className="mr-4">
                  <p className="font-semibold">Followers</p>
                  <p className="text-gray-700">{page.followers}</p>
                </div>
                <div>
                  <p className="font-semibold">Following</p>
                  <p className="text-gray-700">{page.following}</p>
                </div>
              </div>
            </div>

            <div className="mt-4">
              <p className="text-gray-700">{page.about}</p>
            </div>
          </div>
        ) : null}
      </div>

      {userDetail.accessToken.length !== 0 && (
        <section className={styles.headerBlock}>
          <p className={styles.pageTitle}>Story Tracker</p>
          {/* <AddCreators
            triggerText="Add Creator"
            callback={() => {
              // getPageConversations();
              getPageCreators();
            }}
            token={pages[0] ? pages[0]?.accessToken : ""}
            pageId={pages[0] ? pages[0]?.pageId : ""}
          /> */}
        </section>
      )}
      {userDetail?.accessToken.length ? (
        <section className={styles.mainBlock}>
          <Tabs className="TabsRoot" value={tab}>
            <TabsList
              className={styles.TabsList}
              aria-label="Manage your account"
            >
              <TabsTrigger
                className="TabsTrigger"
                value="tab4"
                onClick={() => {
                  setTab("tab4");
                  setSelectedUserName("");
                  setMessage("");
                }}
              >
                Creator marketplace
              </TabsTrigger>
              <TabsTrigger
                className="TabsTrigger"
                value="tab1"
                onClick={() => {
                  setTab("tab1");
                  setSelectedUserName("");
                  setMessage("");
                }}
              >
                Mentions
              </TabsTrigger>
              <TabsTrigger
                className="TabsTrigger"
                value="tab2"
                onClick={() => {
                  setTab("tab2");
                  setSelectedUserName("");
                  setMessage("");
                }}
              >
                Creators
              </TabsTrigger>
              <TabsTrigger
                className="TabsTrigger"
                value="tab3"
                onClick={() => {
                  setTab("tab3");
                  setSelectedUserName("");
                  setMessage("");
                }}
              >
                Chat
              </TabsTrigger>
              <TabsTrigger
                className="TabsTrigger"
                value="tab5"
                onClick={() => {
                  setTab("tab5");
                  setSelectedUserName("");
                  setMessage("");
                }}
              >
                Ads
              </TabsTrigger>
              <TabsTrigger
                className="TabsTrigger"
                value="tab6"
                onClick={() => {
                  setTab("tab6");
                  setSelectedUserName("");
                  setMessage("");
                }}
              >
                Partnerships
              </TabsTrigger>
            </TabsList>

            <TabsContent className="TabsContent" value="tab1">
              {userDetail?.accessToken && (
                <div className={styles.contentHeaderBlock}>
                  <select
                    value={selected}
                    onChange={(e) => setSelected(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    {pages &&
                      pages.map((page: any, i: number) => (
                        <option value={page?._id} key={i}>
                          {page?.name}
                        </option>
                      ))}
                  </select>
                  <button
                    className={styles.primaryButton}
                    disabled={loader || tagsLoading}
                    onClick={() => {
                      toast.info("please wait while we refresh the data");
                      // Story mentions (conversations) + tagged posts/reels
                      // (re-pulled from the Graph API, not the cache).
                      refreshConversations(selected);
                      loadFbTags(true);
                    }}
                  >
                    {tagsLoading || loader ? "Refreshing..." : "Refresh"}
                  </button>
                </div>
              )}
              {loader && <Loader />}
              {!loader && (
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableCell className="font-bold">
                        Creator's Name
                      </TableCell>
                      <TableCell className="font-bold">Username</TableCell>
                      <TableCell className="font-bold">Followers</TableCell>
                      <TableCell className="font-bold">Preview</TableCell>
                      <TableCell className="font-bold">Type</TableCell>
                      <TableCell className="font-bold">
                        Story/Post Time Stamp
                      </TableCell>
                      <TableCell className="font-bold">Status</TableCell>
                      <TableCell className="font-bold">Action</TableCell>
                    </TableRow>
                  </TableHeader>

                  <TableBody>
                    {/* Tagged media (posts + reels) from the /tags edge.
                        Story mentions come from conversations, below. */}
                    {fbTags.map((m: any) => {
                      const rec = adsByMedia[m.id];
                      return (
                        <TableRow key={m.id}>
                          <TableCell className="w-40">
                            <div className="flex">
                              <img
                                src={m.thumbnail_url || m.media_url || fallbackPic}
                                alt={`${m.username} post`}
                                className="object-cover w-10 h-10 mr-2 rounded"
                                onError={(e) => {
                                  (e.currentTarget as HTMLImageElement).src =
                                    fallbackPic;
                                }}
                              />
                              <p className="flex items-center">
                                {m.username ?? "-"}
                              </p>
                            </div>
                          </TableCell>
                          <TableCell className="w-20">
                            <Link
                              to={`https://instagram.com/${m.username}`}
                              target="_blank"
                              className="text-blue-800 underline"
                            >
                              {m.username}
                            </Link>
                          </TableCell>
                          <TableCell width={50}>-</TableCell>
                          <TableCell width={50}>
                            {m.permalink ? (
                              <Link
                                to={m.permalink}
                                target="_blank"
                                className="text-blue-800 underline"
                              >
                                Link
                              </Link>
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          <TableCell width={50}>
                            {m.media_product_type || m.media_type || "-"}
                          </TableCell>
                          <TableCell width={50}>
                            {m.timestamp
                              ? moment(m.timestamp).format("DD-MM-YYYY hh:mm:a")
                              : "-"}
                          </TableCell>
                          {/* Status — boost-permission, driven by the cron */}
                          <TableCell width={90}>
                            {!isBoostable(m) ? (
                              <span className="text-xs text-gray-400">—</span>
                            ) : (
                              (() => {
                                const meta = adStatusMeta(m.adStatus || "none");
                                return (
                                  <span
                                    className={classNames(
                                      "text-white text-[10px] px-2 py-0.5 rounded w-fit inline-block",
                                      meta.cls
                                    )}
                                    title="Set automatically after the ad is pushed; a background job checks the creator's approval every 5 minutes."
                                  >
                                    {meta.label}
                                  </span>
                                );
                              })()
                            )}
                          </TableCell>
                          <TableCell width={50}>
                            {rec ? (
                              <span className="text-xs font-medium text-blue-700">
                                In Ads ✓
                              </span>
                            ) : isBoostable(m) ? (
                              <button
                                className={styles.primaryButton}
                                onClick={() => openBoost(m)}
                              >
                                Boost
                              </button>
                            ) : (
                              <span
                                className="text-xs text-gray-400"
                                title="Stories can't be used for partnership ads — only feed posts and reels."
                              >
                                Not boostable
                              </span>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {/* {tagged &&
                    tagged.map((x: any, i: number) => (
                      <TableRow key={i}>
                        <TableCell className="w-40">
                          <div className="flex">
                            <object
                              data={x.from.profilePicture}
                              type="image/png"
                              className="w-10 h-10 mr-2 rounded-full"
                            >
                              <img
                                className="w-10 h-10 mr-2 rounded-full"
                                src={fallbackPic}
                                alt={`${x.from.name} profile pic`}
                              />
                            </object>
                            <p className="flex items-center">{x.from.name}</p>
                          </div>
                        </TableCell>
                        <TableCell className="w-20">
                          {x.from.username}
                        </TableCell>
                        <TableCell width={50}>
                          {x.from.followers ? x.from.followers : "-"}
                        </TableCell>
                        <TableCell width={50}>
                          <Link
                            to={x?.media}
                            target="_blank"
                            className="text-blue-800 underline"
                          >
                            Link
                          </Link>
                        </TableCell>
                        <TableCell width={50}>{x?.messageType}</TableCell>
                        <TableCell width={50}>
                          {moment(x?.messageCreatedAt).format(
                            "DD-MM-YYYY hh:mm:a"
                          )}
                        </TableCell>
                      </TableRow>
                    ))} */}
                    {conversations?.reverse()?.map((convo: any, i: number) => (
                      <TableRow key={i}>
                        <TableCell className="w-40">
                          <div className="flex">
                            <img
                              src={convo?.creatorId?.profilePic || fallbackPic}
                              alt={`${convo?.from?.username} profile pic`}
                              className="w-10 h-10 mr-2 rounded-full object-cover"
                              onError={(e) => {
                                (e.currentTarget as HTMLImageElement).src =
                                  fallbackPic;
                              }}
                            />
                            <p className="flex items-center">
                              {convo?.creatorId?.name ?? convo?.from?.username}
                            </p>
                          </div>
                        </TableCell>
                        <TableCell className="w-20">
                          <Link
                            to={`https://instagram.com/${convo?.from?.username}`}
                            target="_blank"
                            className="text-blue-800 underline"
                          >
                            {convo?.from?.username}
                          </Link>
                        </TableCell>
                        <TableCell width={50}>
                          {convo?.creatorId?.followers
                            ? convo?.creatorId?.followers
                            : "-"}
                        </TableCell>
                        <TableCell width={50}>
                          {convo?.media.length ? (
                            <Link
                              to={convo?.media}
                              target="_blank"
                              className="text-blue-800 underline"
                            >
                              Link
                            </Link>
                          ) : (
                            <span title="Story expired">
                              🕥 Mentioned you in their story
                            </span>
                          )}
                        </TableCell>
                        <TableCell width={50}>{convo?.messageType}</TableCell>
                        <TableCell width={50}>
                          {moment(convo?.messageCreatedAt).format(
                            "DD-MM-YYYY hh:mm:a"
                          )}
                        </TableCell>
                        <TableCell width={50}>
                          <button
                            className={styles.linkButton}
                            onClick={() => {
                              setSelectedUserName(convo?.from?.username);
                              setTab("tab3");
                              setMessage("Thank you for tagging us!");
                            }}
                          >
                            <Messanger />
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </TabsContent>
            <TabsContent className="TabsContent" value="tab2">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableCell className="font-bold">Creator's Name</TableCell>
                    <TableCell className="font-bold">Username</TableCell>
                    <TableCell className="font-bold">Followers</TableCell>
                  </TableRow>
                </TableHeader>

                <TableBody>
                  {creators
                    ?.filter((x: any) => x.username?.length > 0)
                    ?.map((creator: any, i: number) => (
                      <TableRow key={i}>
                        <TableCell>
                          <div className="flex">
                            <object
                              data={creator.profilePic}
                              type="image/png"
                              className="w-10 h-10 mr-2 rounded-full"
                            >
                              <img
                                className="w-10 h-10 mr-2 rounded-full"
                                src={fallbackPic}
                                alt={`${creator.name} profile pic`}
                              />
                            </object>
                            <p className="flex items-center">{creator.name}</p>
                          </div>
                        </TableCell>
                        <TableCell>{creator?.username}</TableCell>
                        <TableCell>{creator?.followers}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TabsContent>
            <TabsContent className="TabsContent" value="tab3">
              <ChatBox
                selectedUserName={selectedUserName}
                selectPage={pages.find((x) => x._id === selected)}
                message={message}
              />
            </TabsContent>
            <TabsContent className="TabsContent" value="tab4">
              <div className={styles.contentHeaderBlock}>
                <select
                  value={selected}
                  onChange={(e) => setSelected(e.target.value)}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  {pages &&
                    pages.map((p: any, i: number) => (
                      <option value={p?._id} key={i}>
                        {p?.name}
                      </option>
                    ))}
                </select>
                <input
                  type="text"
                  value={marketplaceQuery}
                  onChange={(e) => setMarketplaceQuery(e.target.value)}
                  placeholder="Search query (e.g. fashion)"
                  disabled={!!marketplaceUsername.trim()}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 min-w-[180px] disabled:opacity-50"
                />
                <input
                  type="text"
                  value={marketplaceCountries}
                  onChange={(e) => setMarketplaceCountries(e.target.value)}
                  placeholder="Countries (e.g. US)"
                  disabled={!!marketplaceUsername.trim()}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 w-[120px] disabled:opacity-50"
                />
                <span className="text-gray-400 text-sm self-center">or</span>
                <input
                  type="text"
                  value={marketplaceUsername}
                  onChange={(e) => setMarketplaceUsername(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") loadCreatorMarketplace();
                  }}
                  placeholder="Individual @username"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 min-w-[180px]"
                />
                <button
                  type="button"
                  className={styles.primaryButton}
                  onClick={() => loadCreatorMarketplace()}
                  disabled={marketplaceLoading}
                >
                  Search
                </button>
              </div>
              {marketplaceError && (
                <p className="text-sm text-red-600 mb-2">{marketplaceError}</p>
              )}
              {page && !page.connectedId && (
                <p className="text-sm text-amber-700 mb-2">
                  This Facebook Page has no linked Instagram professional account
                  ID. Reconnect the page in Connect so creator marketplace search
                  can run.
                </p>
              )}
              {marketplaceLoading && <Loader />}
              {!marketplaceLoading && (
                <div className="overflow-x-auto rounded-lg border border-gray-200">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableCell className="font-bold">Creator</TableCell>
                        <TableCell className="font-bold text-center">
                          Message
                        </TableCell>
                        <TableCell className="font-bold">Followers</TableCell>
                        <TableCell className="font-bold">Country</TableCell>
                        <TableCell className="font-bold">Gender</TableCell>
                        <TableCell className="font-bold">Age</TableCell>
                        <TableCell className="font-bold">Verified</TableCell>
                        <TableCell className="font-bold">Email</TableCell>
                        <TableCell className="font-bold min-w-[200px]">
                          Bio
                        </TableCell>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {!marketplaceError && marketplaceRows.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={9} className="text-gray-500">
                            {marketplaceSearchedOnce
                              ? "No creators returned. Try different filters or check API permissions."
                              : "Use Search to load creator marketplace results for this page."}
                          </TableCell>
                        </TableRow>
                      ) : marketplaceRows.length > 0 ? (
                        marketplaceRows.map((c: any, i: number) => (
                          <TableRow
                            key={c.creator_id ?? c.id ?? `mkt-${i}`}
                          >
                            {/* Creator: DP + username */}
                            <TableCell>
                              <div className="flex items-center gap-2">
                                <img
                                  src={c.profile_picture_url || fallbackPic}
                                  alt={c.username || "creator"}
                                  className="w-9 h-9 rounded-full object-cover shrink-0"
                                  onError={(e) => {
                                    (e.currentTarget as HTMLImageElement).src =
                                      fallbackPic;
                                  }}
                                />
                                {c.username ? (
                                  <a
                                    href={`https://instagram.com/${c.username}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-800 underline"
                                  >
                                    {c.username}
                                  </a>
                                ) : (
                                  "—"
                                )}
                              </div>
                            </TableCell>
                            {/* Message (#2) */}
                            <TableCell className="text-center align-middle">
                              {!c.messaging_id ? (
                                <span
                                  className="text-xs text-gray-400"
                                  title="No messaging_id — creator isn't onboarded to Creator Marketplace, is >250k followers, or opted out of partnership messaging."
                                >
                                  Not available
                                </span>
                              ) : (msgSentByCreator[c.messaging_id] || 0) >= 2 ? (
                                <span
                                  className="text-xs text-amber-700"
                                  title="2 messages already sent in the last 30 days (2207095). Wait until the creator replies."
                                >
                                  Limit reached
                                </span>
                              ) : (msgSentByCreator[c.messaging_id] || 0) >= 1 ? (
                                <span
                                  className="text-xs text-gray-500"
                                  title="Already messaged. Continue the conversation in the Partnerships tab."
                                >
                                  Message sent
                                </span>
                              ) : (
                                <button
                                  className={styles.primaryButton}
                                  onClick={() => {
                                    setMsgCreator(c);
                                    setMsgText("");
                                  }}
                                >
                                  Message
                                </button>
                              )}
                            </TableCell>
                            <TableCell>
                              {c.creator_follower_count ?? "—"}
                            </TableCell>
                            <TableCell>{c.country ?? "—"}</TableCell>
                            <TableCell>{c.gender ?? "—"}</TableCell>
                            <TableCell>{c.age_bucket ?? "—"}</TableCell>
                            <TableCell>
                              {c.is_account_verified != null
                                ? String(c.is_account_verified)
                                : "—"}
                            </TableCell>
                            <TableCell className="max-w-[160px] truncate" title={c.email}>
                              {c.email ?? "—"}
                            </TableCell>
                            <TableCell
                              className="max-w-[240px] text-sm align-top"
                              title={String(
                                c.creator_bio ?? c.biography ?? ""
                              )}
                            >
                              {(() => {
                                const bioText = String(
                                  c.creator_bio ?? c.biography ?? ""
                                );
                                if (!bioText) return "—";
                                return bioText.length > 200
                                  ? `${bioText.slice(0, 200)}…`
                                  : bioText;
                              })()}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : null}
                    </TableBody>
                  </Table>
                </div>
              )}
            </TabsContent>

            {/* Ads — live campaign -> ad set -> ad/creative tree from Meta */}
            <TabsContent className="TabsContent" value="tab5">
              <div className="p-4">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-lg font-bold">Ad Campaigns</p>
                  <button
                    className={styles.primaryButton}
                    onClick={loadLiveCampaigns}
                    disabled={liveLoading}
                  >
                    {liveLoading ? "Refreshing..." : "Refresh"}
                  </button>
                </div>
                {liveError ? (
                  <p className="text-red-500">{liveError}</p>
                ) : liveLoading && liveCampaigns.length === 0 ? (
                  <Loader />
                ) : liveCampaigns.length === 0 ? (
                  <p className="text-gray-500">
                    No ads yet. Boost a post or reel from the Mentions tab.
                  </p>
                ) : (
                  <div className="space-y-3">
                    {liveCampaigns.map((c: any) => {
                      const open = !!expandedCampaigns[c.id];
                      const adsets = c.adsets?.data || [];
                      const totalBudget =
                        adsets.reduce(
                          (s: number, a: any) => s + Number(a.daily_budget || 0),
                          0
                        ) || Number(c.daily_budget || 0);
                      const rec = recordForCampaign(c.id);
                      const busy = rec && adActionId === rec._id;
                      return (
                        <div
                          key={c.id}
                          className="overflow-hidden border rounded-lg"
                        >
                          <div className="flex items-center justify-between w-full px-4 py-3 bg-gray-50">
                            <button
                              onClick={() =>
                                setExpandedCampaigns((p) => ({
                                  ...p,
                                  [c.id]: !open,
                                }))
                              }
                              className="flex items-center flex-1 gap-2 text-left"
                            >
                              <span className="text-gray-400">
                                {open ? "▾" : "▸"}
                              </span>
                              <span className="font-semibold">
                                {c.name || "Campaign"}
                              </span>
                              <span className="text-xs text-gray-500">
                                {c.objective}
                              </span>
                            </button>
                            <div className="flex items-center gap-3">
                              <span className="text-sm text-gray-600">
                                ${(totalBudget / 100).toFixed(2)}/day
                              </span>
                              <span
                                className={classNames(
                                  "text-white text-xs px-2 py-1 rounded",
                                  effClass(c.effective_status || c.status)
                                )}
                              >
                                {c.effective_status || c.status}
                              </span>
                              {(() => {
                                const cp = creatorPermissionMeta(c.id);
                                return cp ? (
                                  <span
                                    className={classNames(
                                      "text-white text-xs px-2 py-1 rounded whitespace-nowrap",
                                      cp.cls
                                    )}
                                    title="Whether the creator has allowed their content to be used in ads"
                                  >
                                    {cp.label}
                                  </span>
                                ) : null;
                              })()}
                              {adsManagerUrl(c.id) && (
                                <a
                                  href={adsManagerUrl(c.id) as string}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-xs text-blue-600 underline whitespace-nowrap"
                                  title="Open this campaign in Meta Ads Manager"
                                >
                                  Ads Manager ↗
                                </a>
                              )}
                              {rec && (
                                <div className="flex gap-2 text-xs">
                                  {c.status !== "ACTIVE" && (
                                    <button
                                      disabled={busy}
                                      onClick={() => handleGoLive(rec)}
                                      className="text-green-700 underline disabled:opacity-50"
                                    >
                                      Go live
                                    </button>
                                  )}
                                  {c.status === "ACTIVE" && (
                                    <button
                                      disabled={busy}
                                      onClick={() =>
                                        handleAdStatus(rec, "PAUSED")
                                      }
                                      className="text-yellow-700 underline disabled:opacity-50"
                                    >
                                      Pause
                                    </button>
                                  )}
                                  <button
                                    disabled={busy}
                                    onClick={() => handleDeleteAd(rec)}
                                    className="text-red-600 underline disabled:opacity-50"
                                  >
                                    Delete
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>

                          {open && (
                            <div className="px-4 py-3 space-y-3">
                              {adsets.length === 0 && (
                                <p className="text-xs text-gray-400">
                                  No ad sets.
                                </p>
                              )}
                              {adsets.map((a: any) => {
                                const countries =
                                  a.targeting?.geo_locations?.countries || [];
                                const adList = a.ads?.data || [];
                                return (
                                  <div key={a.id} className="p-3 border rounded">
                                    <div className="mb-2 text-xs text-gray-500">
                                      Ad set: {a.name} · optimize{" "}
                                      {a.optimization_goal} · $
                                      {(
                                        Number(a.daily_budget || 0) / 100
                                      ).toFixed(2)}
                                      /day
                                      {countries.length
                                        ? ` · ${countries.join(", ")}`
                                        : ""}{" "}
                                      · {a.effective_status}
                                      {adsManagerUrl(c.id, a.id) && (
                                        <>
                                          {" · "}
                                          <a
                                            href={
                                              adsManagerUrl(
                                                c.id,
                                                a.id
                                              ) as string
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 underline"
                                            title="Open this ad set in Meta Ads Manager"
                                          >
                                            Ads Manager ↗
                                          </a>
                                        </>
                                      )}
                                    </div>
                                    {adList.length === 0 && (
                                      <p className="text-xs text-gray-400">
                                        No ads.
                                      </p>
                                    )}
                                    <div className="space-y-2">
                                      {adList.map((ad: any) => {
                                        const cr = ad.creative || {};
                                        const info = cr.source_instagram_media_id
                                          ? mediaInfo(
                                              cr.source_instagram_media_id
                                            )
                                          : null;
                                        const thumb =
                                          cr.thumbnail_url ||
                                          cr.image_url ||
                                          info?.thumbnail_url ||
                                          info?.media_url;
                                        return (
                                          <div
                                            key={ad.id}
                                            className="flex items-center gap-3"
                                          >
                                            {thumb ? (
                                              <img
                                                src={thumb}
                                                alt="creative"
                                                className="object-cover w-12 h-12 rounded"
                                              />
                                            ) : (
                                              <div className="w-12 h-12 bg-gray-100 rounded" />
                                            )}
                                            <div className="flex-1">
                                              <div className="text-sm">
                                                {ad.name}
                                              </div>
                                              <div className="text-xs text-gray-500">
                                                {cr.call_to_action_type
                                                  ? `CTA: ${cr.call_to_action_type}`
                                                  : "No CTA"}
                                              </div>
                                            </div>
                                            <span
                                              className={classNames(
                                                "text-white text-xs px-2 py-1 rounded",
                                                effClass(
                                                  ad.effective_status ||
                                                    ad.status
                                                )
                                              )}
                                            >
                                              {ad.effective_status || ad.status}
                                            </span>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </TabsContent>

            {/* Partnerships — Creator Marketplace partnership-folder messages */}
            <TabsContent className="TabsContent" value="tab6">
              <div className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <p className="text-lg font-bold">Partnership messages</p>
                  <button
                    className={styles.primaryButton}
                    onClick={loadPartnershipThreads}
                    disabled={pThreadsLoading}
                  >
                    {pThreadsLoading ? "Loading..." : "Refresh"}
                  </button>
                </div>
                {pThreads.length === 0 && !pThreadsLoading ? (
                  <p className="text-sm text-gray-500">
                    No partnership conversations. Message a creator from the
                    Creator marketplace tab.
                  </p>
                ) : (
                  <div className="flex border rounded h-[420px]">
                    <ul className="w-[220px] border-r overflow-y-auto">
                      {pThreads.map((t: any) => {
                        // Show the creator's username (never the raw thread id).
                        const uname =
                          t.creatorUsername ||
                          t.participants?.data?.find((p: any) => p.username)
                            ?.username;
                        return (
                          <li
                            key={t.id}
                            onClick={() => openPartnershipThread(t.id)}
                            className={classNames(
                              "px-4 py-3 border-b cursor-pointer text-sm",
                              {
                                "bg-blue-500 text-white":
                                  pSelectedThread === t.id,
                              }
                            )}
                          >
                            <div className="font-medium truncate">
                              {uname ? `@${uname}` : "Unknown creator"}
                            </div>
                            {t.updated_time && (
                              <div className="text-xs opacity-70">
                                {moment(t.updated_time).format(
                                  "DD-MM-YYYY hh:mm a"
                                )}
                              </div>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                    <div className="flex flex-col flex-1">
                      <div className="flex-1 p-4 overflow-y-auto">
                        {!pSelectedThread ? (
                          <p className="text-sm text-gray-400">
                            Select a conversation.
                          </p>
                        ) : pMessagesLoading ? (
                          <p className="text-sm text-gray-400">Loading...</p>
                        ) : pMessages.length === 0 ? (
                          <p className="text-sm text-gray-400">No messages.</p>
                        ) : (
                          <ul className="flex flex-col gap-2">
                            {pMessages.map((m: any, i: number) => {
                              const mine =
                                m.from?.id && m.from.id === page?.pageId;
                              return (
                                <li
                                  key={m.id || i}
                                  className={classNames("max-w-[75%]", {
                                    "self-end text-right": mine,
                                    "self-start": !mine,
                                  })}
                                >
                                  <div
                                    className={classNames(
                                      "inline-block px-3 py-2 rounded text-sm",
                                      mine
                                        ? "bg-green-500 text-white"
                                        : "bg-gray-200"
                                    )}
                                  >
                                    {m.message || "(no text)"}
                                  </div>
                                  <div className="text-[10px] text-gray-400 mt-0.5">
                                    {m.from?.username || ""}
                                    {m.created_time
                                      ? ` · ${moment(m.created_time).format(
                                          "DD-MM hh:mm a"
                                        )}`
                                      : ""}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </div>
                      {pSelectedThread &&
                        (partnershipSendBlocked() ? (
                          <div className="p-3 border-t text-xs text-amber-700 bg-amber-50">
                            Message limit reached — a brand may send only 2
                            messages per 30 days until the creator replies.
                          </div>
                        ) : (
                          <div className="flex items-center gap-2 p-2 border-t">
                            <input
                              type="text"
                              value={pReplyText}
                              onChange={(e) => setPReplyText(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") sendPartnershipReply();
                              }}
                              placeholder="Reply..."
                              className="flex-1 px-3 py-2 text-sm border rounded"
                            />
                            <button
                              className={styles.primaryButton}
                              onClick={sendPartnershipReply}
                              disabled={pReplying || !pReplyText.trim()}
                            >
                              {pReplying ? "..." : "Send"}
                            </button>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            </TabsContent>
          </Tabs>
        </section>
      ) : (
        <section className={styles.footerBlock}>
          <p className={styles.pageFooterTitle}>Welcome to Story Tracker</p>
          <p className={styles.pageFooterSubTitle}>
            Please connect your instagram. <Link to="/connect">click here</Link>{" "}
          </p>
        </section>
      )}

      {/* Creator Marketplace partnership message */}
      {msgCreator && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="w-[440px] max-w-[92vw] rounded-lg bg-white p-6 shadow-xl">
            <h3 className="mb-1 text-lg font-bold">
              Message @{msgCreator.username || "creator"}
            </h3>
            <p className="mb-3 text-sm text-gray-500">
              Note: This message will be sent to the Creator's Partnership
              folder on Instagram. Limit: 2 messages / 30 days until they reply.
            </p>
            <textarea
              rows={4}
              autoFocus
              value={msgText}
              onChange={(e) => setMsgText(e.target.value)}
              placeholder="Write your partnership message..."
              className="w-full px-3 py-2 text-sm border rounded"
            />
            <div className="flex justify-end gap-2 mt-4">
              <button
                className="px-3 py-2 text-sm text-gray-800 bg-gray-200 rounded"
                onClick={() => setMsgCreator(null)}
                disabled={msgSending}
              >
                Cancel
              </button>
              <button
                className={styles.primaryButton}
                onClick={sendPartnershipMessage}
                disabled={msgSending || !msgText.trim()}
              >
                {msgSending ? "Sending..." : "Send"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Boost / Partnership Ad form */}
      {boostFor && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="w-[440px] max-w-[92vw] rounded-lg bg-white p-6 shadow-xl">
            <h3 className="mb-1 text-lg font-bold">Boost as Partnership Ad</h3>
            <p className="mb-4 text-sm text-gray-500">
              @{boostFor.username} ·{" "}
              {boostFor.media_product_type || boostFor.media_type} · runs from
              the creator's handle with the Paid Partnership label. Created
              paused.
            </p>
            <div className="space-y-3">
              <div>
                <label className="text-xs text-gray-600">Ad name</label>
                <input
                  className="w-full px-2 py-2 text-sm border rounded"
                  value={boostForm.name}
                  onChange={(e) =>
                    setBoostForm({ ...boostForm, name: e.target.value })
                  }
                />
              </div>
              <div className="flex gap-3">
                <div className="flex-1">
                  <label className="text-xs text-gray-600">Objective</label>
                  <select
                    className="w-full px-2 py-2 text-sm border rounded"
                    value={boostForm.objective}
                    onChange={(e) =>
                      setBoostForm({ ...boostForm, objective: e.target.value })
                    }
                  >
                    <option value="OUTCOME_AWARENESS">Awareness (reach)</option>
                    <option value="OUTCOME_ENGAGEMENT">Engagement</option>
                    <option value="OUTCOME_TRAFFIC">Traffic</option>
                    <option value="OUTCOME_SALES">Sales</option>
                  </select>
                </div>
                <div className="w-28">
                  <label className="text-xs text-gray-600">
                    Daily budget ($)
                  </label>
                  <input
                    type="number"
                    min={1}
                    className="w-full px-2 py-2 text-sm border rounded"
                    value={boostForm.dailyBudgetUsd}
                    onChange={(e) =>
                      setBoostForm({
                        ...boostForm,
                        dailyBudgetUsd: Number(e.target.value),
                      })
                    }
                  />
                </div>
              </div>
              <div>
                <label className="text-xs text-gray-600">
                  Countries (comma-separated)
                </label>
                <input
                  className="w-full px-2 py-2 text-sm border rounded"
                  value={boostForm.countries}
                  onChange={(e) =>
                    setBoostForm({ ...boostForm, countries: e.target.value })
                  }
                />
              </div>
              <div className="flex gap-3">
                <div className="w-36">
                  <label className="text-xs text-gray-600">CTA</label>
                  <select
                    className="w-full px-2 py-2 text-sm border rounded"
                    value={boostForm.ctaType}
                    onChange={(e) =>
                      setBoostForm({ ...boostForm, ctaType: e.target.value })
                    }
                  >
                    <option value="LEARN_MORE">Learn more</option>
                    <option value="SHOP_NOW">Shop now</option>
                    <option value="SIGN_UP">Sign up</option>
                  </select>
                </div>
                <div className="flex-1">
                  <label className="text-xs text-gray-600">
                    CTA link <span className="text-red-500">*</span>
                  </label>
                  <input
                    required
                    type="url"
                    placeholder="https://..."
                    className="w-full px-2 py-2 text-sm border rounded"
                    value={boostForm.ctaLink}
                    onChange={(e) =>
                      setBoostForm({ ...boostForm, ctaLink: e.target.value })
                    }
                  />
                </div>
              </div>
              <label className="flex items-center gap-2 text-sm text-gray-600">
                <input
                  type="checkbox"
                  checked={boostForm.dryRun}
                  onChange={(e) =>
                    setBoostForm({ ...boostForm, dryRun: e.target.checked })
                  }
                />
                Dry run (log payload, create nothing)
              </label>
            </div>
            <div className="flex justify-end gap-2 mt-5">
              <button
                className="px-3 py-2 text-sm text-gray-800 bg-gray-200 rounded"
                onClick={() => setBoostFor(null)}
                disabled={boosting}
              >
                Cancel
              </button>
              <button
                className={styles.primaryButton}
                onClick={submitBoost}
                // Meta requires a destination for the call to action — a CTA type
                // without value.link fails the creative (subcode 2061015).
                disabled={boosting || !boostForm.ctaLink.trim()}
              >
                {boosting ? "Creating..." : "Create ad (paused)"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
